import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AppState } from "../../stores/app.state";
import { Store } from "@ngrx/store";
import { selectIsOauthTokenValid } from "../../stores/auth/auth.selector";
import { UserRouteTrackingService } from "../user-route-tracking/user-route-tracking.service";

export const loginCallbackGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const store = inject(Store<AppState>);
  const userRouteTrackingService = inject(UserRouteTrackingService);

  // const authService = inject(AuthService);

  // console.log("going to login callback from ", window.location.pathname)
  // console.log("going to login callback from ", router.url)

  const isOauthTokenValid = store.selectSignal(selectIsOauthTokenValid)();
  // console.log("loginCallbackGuard.isOauthTokenValid(): ", isOauthTokenValid)

  if (!isOauthTokenValid) return true;
  // const goPage = sessionStorage.getItem("gotopage") ?? "email";
  // const goToEmailPage = goPage.includes("email");
  const goPage = userRouteTrackingService.isLastPageAt();
  // console.log({ goPage });


  return router.createUrlTree([goPage])

};
